import { render, staticRenderFns } from "./registrar-en-nombre.vue?vue&type=template&id=39294275&scoped=true"
import script from "./registrar-en-nombre.vue?vue&type=script&lang=js"
export * from "./registrar-en-nombre.vue?vue&type=script&lang=js"
import style0 from "./registrar-en-nombre.vue?vue&type=style&index=0&id=39294275&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39294275",
  null
  
)

export default component.exports